import { createContext, ReactNode, useState } from "react"
import { gravarSessao, lerSessao, limparSessao } from "../utils/sessao"

export interface ILoginContext {
  name: string
  jwt: string
  perfil: string
  empresa: string
  email: string
  empresaId: string
  pesquisaRespondida: boolean,
  popupVbg:any

  setLogin: (_name: string, _perfil : string, _jwt : string, _empresa : string, _email : string, _empresaId : string, pesquisaRespondida: boolean,popupVbg:any) => Promise<void>
  setLogout: () => Promise<void>

}

export const LoginContext = createContext<ILoginContext>(
  {} as ILoginContext
)

export function LoginContextProvider({
  children,
}: {
  children: ReactNode
}) {
  const [sessaoInicial] = useState(lerSessao)

  const [name, setName] = useState(sessaoInicial?.nome ?? "")
  const [jwt, setJwt] = useState(sessaoInicial?.jwt ?? "")
  const [perfil, setPerfil] = useState(sessaoInicial?.perfil ?? "")
  const [empresa, setEmpresa] = useState(sessaoInicial?.empresa ?? "")
  const [email, setEmail] = useState(sessaoInicial?.email ?? "")
  const [empresaId, setEmpresaId] = useState(sessaoInicial?.empresaId ?? "")
  const [pesquisaRespondida, setPesquisaRespondida] = useState(sessaoInicial?.pesquisaRespondida ?? false)
  const [popupVbg, setPopupVbg] = useState(sessaoInicial?.popupVbg)

  async function setLogin(_name: string, _perfil:string, _jwt: string, _empresa : string, _email : string, _empresaId : string, _pesquisaRespondida: boolean, _popupVbg:any) 
  {
    setName(_name);
    setJwt(_jwt);
    setPerfil(_perfil);
    setEmpresa(_empresa);
    setEmail(_email);
    setEmpresaId(_empresaId);
    setPesquisaRespondida(_pesquisaRespondida)
    setPopupVbg(_popupVbg)
    gravarSessao({
      nome: _name,
      perfil: _perfil,
      jwt: _jwt,
      empresa: _empresa,
      email: _email,
      empresaId: _empresaId,
      pesquisaRespondida: _pesquisaRespondida,
      popupVbg: _popupVbg,
    })
  }

  async function setLogout() {
    setName("");
    setJwt("");
    setPerfil("")
    setEmail("")
    setEmpresa("")
    setEmpresaId("")
    setPesquisaRespondida(false)
    setPopupVbg(undefined)
    limparSessao()
  }


  return (
    <LoginContext.Provider
      value={{ jwt, name, perfil, empresa, email, empresaId, setLogin, setLogout, pesquisaRespondida, popupVbg}}
    >
      {children}
    </LoginContext.Provider>
  )
}
